export function SanitizeClassNames(comp, cn){

    let className = ((comp.props.className || "") + ' ' + (cn || "")).trim();
    //console.log("Class Name:", className)
    className = className.split(' ');

    let ct = {};

    let sanitizedNames = [];

    for(let i=0; i < className.length; i++){
        if(!ct[className[i]]){
            sanitizedNames.push(className[i].trim());
        }
        ct[className[i]] = true;
    }

    return sanitizedNames.join(' ');
}


function elementsIntersect(ele1, ele2){
    return rectIntersects(ele1.getBoundingClientRect(), ele2.getBoundingClientRect());
}

function rectIntersects(a, b){
     if (a.width <= 0 || a.height <= 0 || b.width <= 0 || b.height <= 0){
        return false;
    }
    return !(a.right < b.left || a.bottom < b.top || a.left > b.right || a.top > b.bottom);
}

export function isElementUnderPoint(ele, x, y){
    return rectContainsPoint(ele.getBoundingClientRect(), x, y);
}

function rectContainsPoint(rect, x, y){
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}


// WEBPACK FOOTER //
// ./src/common.js